<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th style="width:50px;max-width:50px" rowspan="4">Kode</th>
                        <th style="width:100px;max-width:100px" rowspan="4">Deskripsi</th>
                        <th colspan="12">Shift</th>
                        <th v-if="thAdd == true" style="width:50px;max-width:50px" rowspan="4">Action</th>
                    </tr>
                    <tr>
                        <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">1</th>
                        <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">2</th>
                        <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">3</th>
                        <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">4</th>
                    </tr>
                    <tr>
                        <th style="width:40px;max-width:40px">Masuk</th>
                        <th style="width:40px;max-width:40px">Keluar</th>
                        <th style="width:40px;max-width:40px">Durasi</th>
                        <th style="width:40px;max-width:40px">Masuk</th>
                        <th style="width:40px;max-width:40px">Keluar</th>
                        <th style="width:40px;max-width:40px">Durasi</th>
                        <th style="width:40px;max-width:40px">Masuk</th>
                        <th style="width:40px;max-width:40px">Keluar</th>
                        <th style="width:40px;max-width:40px">Durasi</th>
                        <th style="width:40px;max-width:40px">Masuk</th>
                        <th style="width:40px;max-width:40px">Keluar</th>
                        <th style="width:40px;max-width:40px">Durasi</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            <template
                                            v-if="item == 'kode' || 
                                            item == 'deskripsi' || 
                                            item == 'tanggal'">
                                                <span :title="body[item]">
                                                    {{body[item]}}
                                                </span>
                                            </template>
                                            <template v-else>
                                                <template 
                                                v-if="item == 'shift1Hari' || 
                                                item == 'shift2Hari' ||
                                                item == 'shift3Hari' ||
                                                item == 'shift4Hari'">
                                                {{body[item]}} Hari
                                                </template>
                                                <template v-else>
                                                    <span class="text-center">
                                                        {{subsLength(body[item])}}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead class="text-center">
                            <tr>
                                <th rowspan="4">Kode</th>
                                <th rowspan="4">Deskripsi</th>
                                <th colspan="12">Shift</th>
                                <th v-if="thAdd == true" rowspan="4">Action</th>
                            </tr>
                            <tr>
                                <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">1</th>
                                <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">2</th>
                                <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">3</th>
                                <th style="background-color:rgba(244, 244, 244, 1)" colspan="3">4</th>
                            </tr>
                            <tr>
                                <th>Masuk</th>
                                <th>Keluar</th>
                                <th>Durasi</th>
                                <th>Masuk</th>
                                <th>Keluar</th>
                                <th>Durasi</th>
                                <th>Masuk</th>
                                <th>Keluar</th>
                                <th>Durasi</th>
                                <th>Masuk</th>
                                <th>Keluar</th>
                                <th>Durasi</th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action'">
                                        <template
                                        v-if="item == 'kode' || 
                                        item == 'deskripsi' || 
                                        item == 'tanggal'">
                                            <span :title="body[item]">
                                                {{body[item]}}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <template 
                                            v-if="item == 'shift1Hari' || 
                                            item == 'shift2Hari' ||
                                            item == 'shift3Hari' ||
                                            item == 'shift4Hari'">
                                            {{body[item]}} Hari
                                            </template>
                                            <template v-else>
                                                <span class="text-center">
                                                    {{subsLength(body[item])}}
                                                </span>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-if="item == 'action'">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data','thAdd', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
        }
    },
    mounted() {
        // this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            // this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        loadStyle(index) {
            let show = ''
            if(index == 1) {
                show = 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
            } else {
                show = 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] + ';' + 'text-align:center;'
            }
            return show
        },
        subsLength(value) {
            let val = value.substr(0, 5)
            return val
        }
        // iconLoad(type, index) {
        //     this.sortIcon = []
        //     let length = this.th.length
        //     var i = 0
        //     if (type == 'sort') {
        //         for(i=0;i<length;i++) {
        //             let onPush = ''
        //             if(index == i) {
        //                 onPush = require('../assets/menu/sort_normal.svg')
        //             } else {
        //                 onPush = require('../assets/menu/sort_active.svg')
        //             }
        //             this.sortIcon.push(onPush)
        //         }
        //     } else {
        //         for(i=0;i<length;i++) {
        //             let onPush = require('../assets/menu/sort_active.svg')
        //             this.sortIcon.push(onPush)
        //         }
        //     }
        // }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 8px;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 8px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 50px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 50px;
    height: 32px;
    float:right;
}
</style>